var map = {
	"./Angels.png": "a323",
	"./Astros.png": "29ec",
	"./Athletics.png": "529e",
	"./Blue Jays.png": "0a85",
	"./Braves.png": "04c7",
	"./Brewers.png": "efc3",
	"./Cardinals.png": "07aa",
	"./Cubs.png": "2552",
	"./Diamondbacks.png": "4802",
	"./Dodgers.png": "1a79",
	"./Giants.png": "cb78",
	"./Indians.png": "9086",
	"./Mariners.png": "0b74",
	"./Marlins.png": "9e96",
	"./Mets.png": "a167",
	"./Nationals.png": "3331",
	"./Orioles.png": "853d",
	"./Padres.png": "03c2",
	"./Phillies.png": "0db2",
	"./Pirates.png": "fcc4",
	"./Rangers.png": "3348",
	"./Rays.png": "fa8b",
	"./Red Sox.png": "f1ad",
	"./Reds.png": "02ac",
	"./Rockies.png": "f8a4",
	"./Royals.png": "11a5",
	"./Tigers.png": "36be",
	"./Twins.png": "df59",
	"./White Sox.png": "cbd1",
	"./Yankees.png": "ced4",
	"./mlb.png": "70de"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9142";